module.exports = __webpack_public_path__ + "img/WXQR.723f94dc.png";